import React from "react";
import styled from "styled-components";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import ViewAppBar from "../views/ViewAppBar";
import ViewFooter from "../views/ViewFooter";
import ViewImportarLeadsPlanilha from "../views/ViewImportarLeadsPlanilha";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const ContainerComponente = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f0f4f7;

  @media (max-width: 768px) {
    padding: 10px;
  }

  @media (max-width: 480px) {
    padding: 5px;
  }
`;

const BackButton = styled.button`
  position: absolute;
  top: 110px;
  left: 40px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  padding: 0.6rem;
  cursor: pointer;
  color: #fff;
  transition: background 0.3s ease, transform 0.2s ease;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
    transform: scale(1.05);
  }

  svg {
    width: 22px;
    height: 22px;
  }

  @media (max-width: 768px) {
    top: 90px;
    left: 20px;
    padding: 0.5rem;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

const ImportarLeadsPlanilha: React.FC = () => {
  const { isLoading, isValid } = usePermissao("OPE");
  const navigate = useNavigate();

  const handleVoltar = () => {
    navigate("/marketing");
  };

  if (isLoading) return <p>Verificando permissão...</p>;
  if (!isValid) return null;

  return (
    <ContainerComponente>
      <BackButton onClick={handleVoltar} title="Voltar">
        <ArrowLeft />
      </BackButton>
      <ViewAppBar />
      <ViewImportarLeadsPlanilha />
      <ViewFooter />
    </ContainerComponente>
  );
};

export default ImportarLeadsPlanilha;
